import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tag",
  "use": "icon-tag-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 8\" id=\"icon-tag\">\n  <path id=\"icon-tag_路径_9160\" data-name=\"路径 9160\" d=\"M14,203.495c0,1.277-2.887,4-7,4-4.009,0-7-2.68-7-4s3-4,7-4c4.146,0,7,2.676,7,4Zm-6.994-3.268a3.272,3.272,0,1,0,0,6.54,3.272,3.272,0,1,0,0-6.54ZM7,201.409a2.083,2.083,0,1,0,2.148,2.082A2.116,2.116,0,0,0,7,201.409Z\" transform=\"translate(0 -199.497)\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tag.svg
// module id = 0dAG
// module chunks = 102